import React, { Component } from 'react';

// Styles
import Inner from './Inner';

export default class FooterTagline extends Component {
  render() {
    return (
      <Inner>
        <div className="tagline">
          <span className="taglineText">Specialister i Danmark</span>
        </div>
      </Inner>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/FooterTagline.js